import type { useDeveloperHasPermission } from "@services/useDeveloperHasPermission";

export const hasLandingPagesPermissions = ({
  hasPermission,
}: {
  hasPermission: ReturnType<typeof useDeveloperHasPermission>;
}) => {
  const hasReadPermission = hasPermission("appGroup", { permission: "readLandingPages" });
  const hasDraftPermission = hasPermission("appGroup", { permission: "createLandingPageDrafts" });
  const hasPublishPermission = hasPermission("appGroup", { permission: "publishLandingPages" });

  const canReadLandingPages = hasReadPermission || hasDraftPermission || hasPublishPermission;
  const canCreateLandingPages = hasDraftPermission || hasPublishPermission;
  const canPublishLandingPages = hasPublishPermission;

  return {
    canReadLandingPages,
    canCreateLandingPages,
    canPublishLandingPages,
  };
};
